<template>
  <Appendix
    title="Phụ lục giao dịch MOTO"
    :fields="fieldsTable"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
  >
    <template #row-details="item">
      <DeviceInfoAppendix :items="[item.appendixMoto]" :fields="deviceFields" />
      <p v-if="Array.isArray(item.appendixMoto.motoType) && item.appendixMoto.motoType.length">
        Loại phụ lục Moto:
        <span v-for="(type, idx) in item.appendixMoto.motoType" :key="type">
          {{ type | transformData(listMoto)
          }}<span v-if="idx < item.appendixMoto.motoType?.length - 1">, </span>
        </span>
      </p>
      <p v-else-if="item.appendixMoto.motoType">
        Loại phụ lục Moto: {{ item.appendixMoto.motoType | transformData(listMoto) }}
      </p>
      <p v-if="item.appraisalStatus">
        Tình trạng thẩm định MPOS:
        {{ item.appraisalStatus | transformData(Config.statusDeterminedMpos) }}
      </p>
      <p v-if="item.appraiser">Người thẩm định/yêu cầu bổ sung: {{ item.appraiser }}</p>
      <p v-if="item.appraisalTime">
        Thời gian thẩm định/yêu cầu bổ sung:
        {{ item.appraisalTime | formatDate('HH:mm, DD/MM/YYYY') }}
      </p>
    </template>
    <template #file="item">
      <AppendixMotoFile :item="item" :contract="contract" />
    </template>
  </Appendix>
</template>
<script>
  import Appendix from './Appendix.vue'
  import DeviceInfoAppendix from './DeviceInfoAppendix.vue'
  import AppendixMotoFile from './files/AppendixMotoFile.vue'
  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: { Appendix, DeviceInfoAppendix, AppendixMotoFile },
    data() {
      return {
        fieldsTable: [
          { key: 'code', label: 'Số phụ lục', class: 'text-left' },
          {
            key: 'time',
            label: 'Thời gian',
            class: 'text-left',
            thStyle: 'min-width: 210px',
          },
          { key: 'state', label: 'Trạng thái', class: 'text-center' },
          { key: 'action', label: 'Thao tác', class: 'text-center' },
        ],
        listMoto: [
          {
            id: 'MOTO_REAL_CARD',
            text: 'Moto thẻ thật',
          },
          {
            id: 'MOTO_ONLINE_CARD',
            text: 'Moto thẻ ảo',
          },
        ],
        deviceFields: [
          {
            key: 'deposit',
            label: 'Tiền cọc',
            class: 'text-right',
            formatter: value => this.$options.filters.fomatCurrency(value),
          },
          {
            key: 'otaValue',
            label: 'OTA trung bình',
            class: 'text-right',
            formatter: value => this.$options.filters.fomatCurrency(value),
          },
          { key: 'hotelLevel', label: 'Hạng khách sạn', class: 'text-left' },
          { key: 'hotelWebsite', label: 'Link khách sạn', class: 'text-left' },
          { key: 'otaUrl', label: 'Link OTA', class: 'text-left' },
          { key: 'note', label: 'Ghi chú', class: 'text-left' },
        ],
      }
    },
  }
</script>

<style scoped></style>
